import client from "../server/Client";
import {useQuery} from "@tanstack/react-query";

const formsFields = (formId) => client.get(`forms/${formId}/sections`);
export const useFormFields = (formId) => useQuery(['formFields', formId],
    () => formsFields(formId),
    {select: data => data?.data?.result})